'use client';

import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function useTranslation() {
  const { translations } = useLanguage();

  const t = useCallback((key: string, params?: Record<string, string | number>): string => {
    const keys = key.split('.');
    let value: unknown = translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = (value as Record<string, unknown>)[k];
      } else {
        return key;
      }
    }

    if (typeof value !== 'string') {
      return key;
    }

    if (params) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey: string) => {
        return params[paramKey]?.toString() || match;
      });
    }

    return value;
  }, [translations]);

  return { t };
}
